import React from 'react';
import styled from 'styled-components';
import { Calendar } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { theme } from '../../../styles/theme';
import { level1Content } from '../../../styles/shareableStyles';

export const CalendarComponent = styled((props: any) => (
  <Calendar {...props} />
))`
  flex: 1;
  ${level1Content};
  .rbc-month-view {
    border: 0;
  }
  .rbc-header {
    padding-top: 7px;
    padding-bottom: 7px;
    border-bottom-color: ${theme.colors.border};
    text-transform: uppercase;
    font-size: 14px;
    line-height: normal;
    color: ${theme.colors.secondary800};
  }
  .rbc-header + .rbc-header {
    border-left: 0;
  }
  .rbc-day-bg {
    background-color: ${theme.colors.level1};
    &.dirty,
    &:hover {
      background-color: ${theme.colors.blue500};
      cursor: pointer;
    }
  }
  .rbc-day-bg + .rbc-day-bg {
    border-left-color: ${theme.colors.border};
  }
  .rbc-month-row {
    min-height: 100px;
  }
  .rbc-month-row + .rbc-month-row {
    border-top-color: ${theme.colors.border};
  }
  .rbc-date-cell {
    padding: 8px;
    text-align: center;
  }
  .rbc-button-link {
    position: relative;
    z-index: 1;
    line-height: normal;
  }
  .rbc-now .rbc-button-link {
    color: #fff;
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: ${theme.colors.mainBlue};
      z-index: -1;
    }
  }
  .rbc-off-range .rbc-button-link {
    color: ${theme.colors.secondary400};
  }
  .rbc-row-segment {
    margin-bottom: 4px;
  }

  // pointer-events hack is used to make our
  // custom modals work
  .rbc-row-content,
  .rbc-row-content .rbc-row {
    pointer-events: none;
  }
  .rbc-row-segment {
    .rbc-event,
    .rbc-show-more {
      pointer-events: all;
    }
  }

  .rbc-month-view > :last-child {
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .rbc-button-link.rbc-show-more {
    padding-left: 6px;
    font: inherit;
    font-size: 12px;
    font-weight: 600;
    color: ${theme.colors.secondary800};
    background: unset;
    &:hover {
      color: ${theme.colors.mainBlue};
    }
  }
`;

export const IncidentTypesLegend = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  column-gap: 16px;
`;
